import React, { Suspense, lazy } from "react";
import Loading from "./components/Loading/index.js";

// Lazy loading de componentes principais
const Dashboard = lazy(() => import("views/Dashboard/Dashboard.js"));
const VisaoGeral = lazy(() => import("components/VisaoGeral"));
const ContaCorrente = lazy(() => import("views/Dashboard/contacorrente.js"));
const LoginPage = lazy(() => import("views/Pages/LoginPage.js"));
const RegisterPage = lazy(() => import("views/Pages/Registro.js"));
const Frota = lazy(() => import("./components/Frota"));
const EditarPlaca = lazy(() => import("components/editarplaca.js"));
const Motorista = lazy(() => import("./components/Motorista"));
const EditarMotorista = lazy(() => import("components/editarMotorista"));
const Empresa = lazy(() => import("components/Empresa"));
const VisualizarFatura = lazy(() => import("components/VisualizarFatura"));
const Faturas = lazy(() => import("components/Faturas"));
const RequisicaoAbast = lazy(() => import("views/Dashboard/RequisicaoAbastecimento"));
const VisualizarRequisicao = lazy(() => import("components/VisualizarRequisicao"));
const ExtratoConsumo = lazy(() => import("components/ExtratoConsumo"));
const recuperaSenha = lazy(() => import("components/RecuperaSenha"));

// @material-ui/icons
import Apps from "@material-ui/icons/Apps";
import DashboardIcon from "@material-ui/icons/Dashboard";
import DateRange from "@material-ui/icons/DateRange";
import GridOn from "@material-ui/icons/GridOn";
import Image from "@material-ui/icons/Image";
import Place from "@material-ui/icons/Place";
import Timeline from "@material-ui/icons/Timeline";
import WidgetsIcon from "@material-ui/icons/Widgets";

var dashRoutes =  [
  {
    path: "/VisaoGeral",
    name: "Visão Geral",
    icon: DashboardIcon,
    component: VisaoGeral,
    layout: "/admin"
  },
  {
    path: "/dashboard",
    name: "Em Aberto",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin"
  },
  {
    collapse: true,
    name: "Cadastros",
    icon: Image,
    state: "pageCollapse",
    views: [
      {
        path: "/Empresa",
        name: "Empresa",
        component: Empresa,
        layout: "/admin"
      },
      {
        path: "/Frota",
        name: "Frota",
        component: Frota,
        layout: "/admin"
      },
      {
        path: "/Motorista",
        name: "Motorista",
        component: Motorista,
        visible: false,
        layout: "/admin"
      },
      {
        path: "/recuperaSenha",
        name: "Trocar senha",
        component: recuperaSenha,
        visible: false,
        layout: "/admin"
      }
    ]
  },
  {
    collapse: true,
    name: "Financeiro",
    icon: Apps,
    state: "FinanceiroCollapse",
    views: [
      {
        path: "/Faturas",
        name: "Faturas",
        mini: "PP",
        component: Faturas,
        layout: "/admin"
      },
      {
        path: "/RequisicaoAbastecimento",
        name: "Requisição Abastecimento",
        mini: "ra",
        component: RequisicaoAbast,
        layout: "/admin"
      },
      {
        path: "/ContaCorrente",
        name: "Conta Corrente",
        mini: "cc",
        component: ContaCorrente,
        layout: "/admin"
      }
    ]
  },
  {
    collapse: true,
    name: "Relatórios",
    icon: Timeline,
    state: "RelatorioCollapse",
    views: [
      {
        path: "/extratoconsumo",
        name: "Extrato Consumo",
        component: ExtratoConsumo,
        layout: "/admin",
        visible: true
      }
    ]
  },
  {
    path: "/login-page",
    component: LoginPage,
    layout: "/auth"
  },
  {
    path: "/register-page",
    component: RegisterPage,
    layout: "/auth"
  },
  {
    path: "/editarplaca/novo/:idCentro",
    component: EditarPlaca,
    layout: "/admin",
    visible: false
  },
  {
    path: "/editarplaca/centro/:id",
    component: EditarPlaca,
    layout: "/admin",
    visible: false
  },
  {
    path: "/editarplaca/:id",
    component: EditarPlaca,
    layout: "/admin",
    visible: false
  },
  {
    path: "/editarmotorista/:id",
    component: EditarMotorista,
    layout: "/admin",
    visible: false
  },
  {
    path: "/visualizarequisicao/:id",
    component: VisualizarRequisicao,
    layout: "/admin",
    visible: false
  },
  {
    path: "/visualizarfatura/:id",
    component: VisualizarFatura,
    layout: "/admin",
    visible: false
  }  



];
export default dashRoutes;
